module.exports = __webpack_public_path__ + "media/images/icon-mask-bread-9cf330f0bfebcc5450fb9cc2d26d328c.png";